import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useToast } from "@chakra-ui/react";
import {
  Box,
  Tooltip,
  FormControl,
} from "@chakra-ui/react";
import { 
  MdDownload as IcoDownload, 
  MdOpenInNew as IcoOpen, 
} from 'react-icons/md';
import "./filesList.css";
// Actions
import * as filesActions from "../../redux/actions/files";
// Utils
import { getToastOpt } from "../../utils/utils";
import { formatBytes } from '../../utils/formatters';

const FilesList = ({
  type,
  id,
  id2,
  setIsLoading,
  label = "Fitxers adjunts",
}) => {
  const dispatch = useDispatch();
  const toast = useToast();
  // States
  const [files, setFiles] = useState([]);
  
  useEffect(() => {
    if (!id) return;

    // Get files
    setIsLoading(true);
    dispatch(filesActions.getFiles(type, id, id2)).then(
      (response) => {
        setIsLoading(false);
        setFiles(response);
      },
      (err) => {
        setIsLoading(false);
        toast(getToastOpt({
          title: `Error obtenint fitxers`,
          description: err,
          status: "error",
        }));
      }
    );
  }, [id]);

  const handleDownloadFile = (file) => {
    console.log(`Downloading ${file.name}..`);
    setIsLoading(true);
    dispatch(filesActions.downloadFile(type, file.id)).then(
      (response) => {
        setIsLoading(false);
        console.log(`Downloaded response`, response);
        // const blob = await response.blob();
        const blob = response; // Ja és un Blob
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = file.name; // Nom de l'arxiu a descarregar
        link.click();
      },
      (err) => {
        setIsLoading(false);
        toast(getToastOpt({
          title: `Error descarregant arxiu`,
          description: err,
          status: "error",
        }));
      }
    );
  };

  const handleOpenFile = (file) => {
    console.log(`Opening ${file.name}..`);
    const newWindow = window.open(file.url, '_blank');
    newWindow.focus();
  };

  const renderFile = (file, i) => {    
    const typePieces = file.type.split("/");
    let type = typePieces.length > 1 ? typePieces[1] : typePieces[0];
    type = (type || '').length > 10
      ? `${type.substring(0, 10).toUpperCase()}...`
      : (type || '').toUpperCase();
    return (
      <div className="fileslist-file-wrapper">
        <div className="fileslist-file-type">
          {type}
        </div>
        <div className="fileslist-file-name-wrapper">
          <Tooltip 
            label={
              <Box p="10px">
                <div className="fileslist-tooltip-label">METADADES</div>
                <Box mt="5px">
                  <div className="fileslist-tooltip-label">Descripció</div>
                  <div className="fileslist-tooltip-field">{!!file.description ? file.description : "-"}</div>
                </Box>
              </Box>
            }
            hasArrow      
            bg="#e9e9e9" // Set the background color here
            color="dark" // Set text color if needed
            borderRadius="5px" // Border radius for rounded corners   
            arrowSize={15} // Size of the arrow                                           
          >
            <div className="fileslist-file-name">
              {file.name}
            </div>
            <div className="fileslist-file-size">
              {formatBytes(file.size)}
            </div>
          </Tooltip>
        </div>  
        <div className="fileslist-file-download" 
          onClick={() => {
            handleDownloadFile(file)
          }}
        >
          <IcoDownload size={18} />
        </div>              
        <div className="fileslist-file-open" 
          onClick={() => {
            handleOpenFile(file)
          }}
        >
          <IcoOpen size={18} />
        </div>
      </div>
    );
  };

  return (
    <div className="fileslist-wrapper">
      <FormControl h="100%" display="flex" flexDirection="column" mt={0}>
        {!!label && files.length > 0 && (
          <Box className="maintenance-detail-label">
            {label}
          </Box>    
        )}  
        {files.map((file, i) => {
          return renderFile(file, i);
        })}
      </FormControl> 
    </div>    
  );
};

export default FilesList;
